import {
    createCssForGridDataRowBackground,
    createCssForGridBorder,
    generateTableRowColors,
} from "./tableRow";
import { DynamicCssModel } from "../../../models/DynamicCssModel";
import {
    createCssForGridHeaderBackground,
    createCssForGridHeader,
    generateTableHeaderColors,
} from "./tableHeader";

function generateGridRowBackgroundCss(theme: object, dynamicCss: DynamicCssModel) {
    const {
        primaryColor,
        secondaryColor,
        secondaryBgColor,
        primaryBgColor,
        selectedBgColor,
        hoverColor,
        hoverBgColor,
        selectedColor,
    } = generateTableRowColors(dynamicCss, theme);

    return createCssForGridDataRowBackground(
        dynamicCss,
        primaryColor,
        secondaryColor,
        primaryBgColor,
        secondaryBgColor,
        hoverColor,
        hoverBgColor,
        selectedColor,
        selectedBgColor,
    );
}

function generateGridHeaderCss(theme: object, dynamicCss: DynamicCssModel) {
    const { color, bgColor } = generateTableHeaderColors(dynamicCss, theme);
    return createCssForGridHeaderBackground(bgColor, color);
}

export function generateGridCss(dynamicCss: DynamicCssModel, theme: object): string[] {
    return [
        generateGridRowBackgroundCss(theme, dynamicCss),
        createCssForGridBorder(theme, dynamicCss),
        generateGridHeaderCss(theme, dynamicCss),
        createCssForGridHeader(theme, dynamicCss),
    ];
}
